import { render, staticRenderFns } from "./categoryAnimal.vue?vue&type=template&id=38d5163f&scoped=true&"
import script from "./categoryAnimal.vue?vue&type=script&lang=js&"
export * from "./categoryAnimal.vue?vue&type=script&lang=js&"
import style0 from "./categoryAnimal.vue?vue&type=style&index=0&id=38d5163f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d5163f",
  null
  
)

export default component.exports